import { DOCUMENT, isPlatformBrowser, Location } from '@angular/common';
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';
import { ThemeSwitcherService } from './theme-switcher.service';

export const provideThemeTransfer = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideAppInitializer(() => {
      if (!isPlatformBrowser(inject(PLATFORM_ID))) return;

      const win = inject(DOCUMENT).defaultView;
      if (!win) return;
      const themeSwitcher = inject(ThemeSwitcherService);
      const location = inject(Location);

      const params = new URLSearchParams(win.location.search);
      const theme = params.get('theme');
      if (theme !== 'light' && theme !== 'dark' && theme !== 'system') return;

      themeSwitcher.setTheme(theme);

      params.delete('theme');
      location.replaceState(
        win.location.pathname + win.location.hash,
        params.toString(),
      );
    }),
  ]);
